import { Layout } from 'antd';
import cn from 'classnames';
import * as React from 'react';

import { PropsWithClassName } from 'types/common';

import { Spacing, SpacingUnit, Logo } from '../../ui';

import s from './LoginLayout.module.scss';

const LoginLayout: React.FC<React.PropsWithChildren<PropsWithClassName>> = ({
  className,
  children,
}) => {
  return (
    <Layout.Content className={cn(s.layout, className)}>
      <Spacing spacing={SpacingUnit.unit4}>
        <div className={s['layout__logo-wrapper']}>
          <Logo />
        </div>
      </Spacing>
      <div className={s.layout__content}>{children}</div>
    </Layout.Content>
  );
};

export default LoginLayout;
